(function($) {
/*	if($('body.form').length) {
		function hideBlock(class_name) {
			var block = $('.'+class_name+'-container');
			block.addClass('hidden');
			block.find('label').removeClass('required');
			block.find('.form-control').removeClass('required');
		}
		function showBlock(class_name) {
			var block = $('.'+class_name+'-container');
			block.removeClass('hidden');
			block.find('label:not(.no-require)').addClass('required');
			block.find('.form-control:not(.no-require)').addClass('required');
		}

		$('#meeting_address_change_yes').click(function() {
			if($('#meeting_address_change_yes').is(':checked')) {
				hideBlock('meeting-address');
			}
		});
		$('#meeting_address_change_no').click(function() {
			if($('#meeting_address_change_no').is(':checked')) {
				showBlock('meeting-address');
			}
		});

		$('#primary_contact_change_yes').click(function() {
			if($('#primary_contact_change_yes').is(':checked')) {
				hideBlock('primary-contact');
			}
		});
		$('#primary_contact_change_no').click(function() {
			if($('#primary_contact_change_no').is(':checked')) {
				showBlock('primary-contact');
			}
		});


		$('#church_attendance').number( true, 0);
		$('#donation_amount').number( true, 2 );
		$('#church_attendance').on('keyup paste',function() {
			church_attendance = parseInt($('#church_attendance').val());
			if($.isNumeric(church_attendance)) {
				if(church_attendance<=1) {
					$('.donation_suggestion').addClass('hidden');
					$('#donation_amount').val('');
				} else {
					suggestedDonation = church_attendance*1;
					if(suggestedDonation<90) {
						suggestedDonation = 90;
					}
					$('#donation_amount').val(suggestedDonation);
					$('.donation_suggestion').removeClass('hidden');
					$('.donation_suggestion .attendance').html(church_attendance);
					$('.donation_suggestion .suggestedDonation').html(suggestedDonation);
				}
			}
		});

		$('#org_turnover').on('change',function() {
			org_turnover = $('#org_turnover').val();
			if(org_turnover == 'Less than 10k') {
				$('#donation_amount').val(85);
				$('.suggestedDonation').html(85);
			} else if(org_turnover == '10k to 100k') {
				$('#donation_amount').val(125);
				$('.suggestedDonation').html(125);
			} else if(org_turnover == '100k to 500k') {
				$('#donation_amount').val(175);
				$('.suggestedDonation').html(175);
			} else if(org_turnover == '500k to 1mil') {
				$('#donation_amount').val(225);
				$('.suggestedDonation').html(225);
			} else if(org_turnover == 'Over 1mil') {
				$('#donation_amount').val(275);
				$('.suggestedDonation').html(275);
			}
		});

		$(document).on('submit','#church_details,#org_details,#ind_details',function(e) {
			showLoadingBar();
			$('.form-btn').addClass('spinner');
		});

		$('#church_details').validate({
			rules: {
				"mem_num": {
					required: true,
					number: true
				},
				"church_attendance": {
					required: true,
					number: true
				},
				"primaryEmailAddress": {
					email: true
				},
				"billing_email": {
					required: true,
					email: true
				},
				"donation_amount": {
					number: true,
					required: true
				}
			},
			messages: {
				email: {
					required: "Please enter your email address",
					email: "Please enter a valid email address"
				}
			}
		});
		$('#org_details').validate({
			rules: {
				"mem_num": {
					required: true,
					number: true
				},
				"org_turnover": {
					required: true
				},
				"primaryEmailAddress": {
					email: true
				},
				"billing_email": {
					required: true,
					email: true
				},
				"donation_amount": {
					number: true,
					required: true
				}
			},
			messages: {
				email: {
					required: "Please enter your email address",
					email: "Please enter a valid email address"
				}
			}
		});
		$('#ind_details').validate({
			rules: {
				"mem_num": {
					required: true,
					number: true
				},
				"billing_email": {
					required: true,
					email: true
				},
				"donation_amount": {
					number: true,
					required: true
				}
			},
			messages: {
				email: {
					required: "Please enter your email address",
					email: "Please enter a valid email address"
				}
			}
		});
	}
	*/
})(jQuery);
